import asyncCom from '@/CommonDP/commons/asyncCom';
import { MessageBox } from 'element-ui';
import priviService from "@/CommonDP/service/privi-service";
import orgFrameworkConfigService from '@/CommonDP/service/admin/orgFrameworkConfig-service';

export const openDoc = async (props) => {
  const { default: DocDialog } = await import('./Doc.vue');
  return asyncCom(DocDialog, undefined, props);
};
export const openUser = async (props) => {
  const component = (await import('./select-user.vue')).default;
  return asyncCom(component, {}, props);
};
/**
 * @description 一个输入不能为空和最大值限制的输入框 默认最大50字,自动去除空格
 * @param {import("element-ui/types/message-box").ElMessageBoxOptions} options
 * @param {function} options.next  延时方法返回promise对象
 * @param {number} options.max  最大字数 默认50
 * @param {string} options.emptyText   为空提示 默认使用options.inputErrorMessage
 * @param {string} options.maxText   超出提示 默认使用option.inputErrorMessage
 * @returns {Promise}
 */
export const inputMsgBox = (options) => {
  const {
    next,
    max = 50,
    emptyText,
    maxText,
    inputErrorMessage,
    inputValidator,
    ...option
  } = options;
  option.$type = "prompt";
  option.showInput = true;
  option.showCancelButton = true;
  option.closeOnClickModal = false;
  option.inputValidator = (name = "") => {
    const text = name ? name.trim() : "";
    if (text.length > max) return maxText || inputErrorMessage;
    else if (text.length < 1) return emptyText || inputErrorMessage;
    else return inputValidator ? inputValidator(text) : true;
  };
  option.beforeClose = async (action, instance, done) => {
    const value = (instance.inputValue || "").trim();
    if (action === "confirm") {
      instance.confirmButtonLoading = true;
      try {
        await next?.(value);
        instance.inputValue = value;
        done();
      } finally {
        instance.confirmButtonLoading = false;
      }
    } else {
      done();
    }
  };
  return MessageBox(option);
};

async function getChooseComponent() {
  const store = require("@/store/index").default;
  const component = await import("@/CommonDP/components/processComponents/config/choosePeople.vue");
  return {
    extends: component.default,
    store,
    created() {
      this.openDialog();
      this.$on('userSelected', this.resolve);
    },
    methods: {
      async closeDialog() {
        this.personChooseDialog = false;
        await this.$nextTick();
        this.reject();
      }
    }
  };
}
// 选择系统角色
export async function openRolePanel(props = {}) {
  const newComponent = await getChooseComponent();
  return asyncCom(newComponent, undefined, {
    canFilterByRole: false,
    canSelectspecRole: false,
    canSelectprojectRole: false,
    ...props
  });
}
// 系统角色 -> 人员
export async function open_Custom_SysRole({ data, enterpriseId, range = [] }) {
  const tab = {
    data,
    label: "系统角色",
    id: "custom-role",
    async get(node) {
      const isRoot = !node.level;
      let list;
      if (!isRoot) {
        const { key: roleId, label: roleName } = node;
        const params = { roleId, enterpriseId, roleName };
        const { data } = await priviService.getSysRoleUserList(params);
        list = data.map((raw) => ({ raw, leaf: true, id: raw.userId, label: raw.name, icon: "el-icon-user" }));
      } else {
        list = range.map((raw) => ({ raw, leaf: false, id: raw.roleID, label: raw.roleName }));
      }
      return list;
    }
  };
  return await openUser({
    title: "选择人员",
    getTabs: () => [tab]
  });
}
// 组织架构 ->人员
export async function open_Frame_User({ data, enterpriseId }) {
  const cache_dept = [];
  const tab = {
    data,
    label: "组织架构",
    id: 'frame-work',
    async get(node) {
      const isRoot = !node.level;
      const list = [];
      const pid = node.key || '0';
      if (isRoot) {
        const { data } = await orgFrameworkConfigService.getOrgTree(enterpriseId);
        cache_dept.push(...data);
        for (const dept of cache_dept) {
          const { children } = dept;
          children && cache_dept.push(...children);
        }
      }
      const deptList = cache_dept
        .filter(({ parentDeptId }) => parentDeptId === pid)
        .map((dept) => ({
          id: dept.deptId,
          label: dept.deptName,
          raw: dept,
          leaf: false
        }));
      list.push(...deptList);
      if (!isRoot) {
        const { data: users } = await orgFrameworkConfigService.orgUserList({
          deptId: pid,
          pageNum: 1,
          pageSize: 999,
          enterpriseId,
          isQueryAll: 0
        });
        const userList = users.map((user) => ({
          id: user.userId,
          label: user.name,
          raw: user,
          leaf: true,
          icon: "el-icon-user"
        }));
        list.push(...userList);
      }
      return list;
    }
  };
  return await openUser({
    title: "组织架构",
    getTabs: () => [tab]
  });
}
async function authGroupSubjectDialog(subList) {
  const component = (await import('@/CommonDP/pages/mainMg/lowcode/metadata/component/metaPage/authGroupSubjectDialog.vue')).default;
  return {
    extends: component,
    created() {
      this.open(subList);
      this.$on('selected', this.resolve);
      this.$on('close', this.reject);
    }
  };
}
export async function open_dept_dialog(selected, props) {
  const subType = {
    subjectCode: "Dept",
    subjectName: "部门"
  };
  const component = await authGroupSubjectDialog([{
    ...subType,
    checked: false,
    childList: []
  }]);
  const newProps = { checkStrictly: true, ...props };
  if (selected?.length) {
    newProps.selected = [{
      ...subType,
      subjectValues: selected,
      values: selected.map(({ value }) => value)
    }];
  }
  return asyncCom(component, {}, newProps);
}
export async function openSetIdentifier(props) {
  const component = (await import('./identifier/index.vue')).default;
  return asyncCom(component, {}, props);
}
